import { useMaintenanceApi } from '../services/api/maintenanceApi';

interface Perfil {
  Id: number;
  Nombre: string;
  Activo: boolean;
  Eliminado: boolean;
}

export const usePerfilesApi = () => {
  return useMaintenanceApi('perfiles');
};